import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2de564a3&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de564a3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2de564a3')) {
      api.createRecord('2de564a3', component.options)
    } else {
      api.reload('2de564a3', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2de564a3&scoped=true&", function () {
      api.rerender('2de564a3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/master_client_company/index.vue"
export default component.exports